import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Box } from '@mui/material';
import useMediaQueries from '../../../hooks/useMediaQueries';
const Container = styled(Box, {
    shouldForwardProp: prop => prop !== 'isWithinPageContent',
}) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  ${({ isWithinPageContent, theme }) => isWithinPageContent && `
  border-bottom: ${theme.palette.divider} solid 1px;`}
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding-left: var(--standard-spacing-x, 24px);
  padding-right: var(--standard-spacing-x, 24px);
`;
;
/**
 * PageHeaderContainer is a container for PageHeader and any component we want to the right of the PageHeader.
 *
 */
const PageHeaderContainer = ({ children, isWithinPageContent = false, ...muiProps }) => {
    const { fitForDesktop, fitForTablet, fitForMobile, } = useMediaQueries();
    const paddingYMap = {
        '24px': fitForDesktop,
        '16px': fitForTablet,
        '12px': fitForMobile,
    };
    const paddingY = Object.entries(paddingYMap).reduce((acc, [key, value]) => {
        if (value)
            return key;
        return acc;
    }, '12px');
    return (_jsx(Container, { className: "header-container", isWithinPageContent: isWithinPageContent, py: paddingY, ...muiProps, children: children }));
};
export default PageHeaderContainer;
//# sourceMappingURL=index.js.map